<template>
  <Vue-select
    class="custom-vue-select"
    v-model="selectedInternal"
    :options="data"
    label="name"
    placeholder="Escribir..."
    :reduce="data => data.id.toString()"
    @click="clearSelection"
    :components="{Deselect}"
  >
  <template v-slot:no-options="{ data, searching }">
    <template v-if="searching">
      <em style="opacity: 0.5">No se encontraron resultados {{ data }}</em>
    </template>
    <em v-else style="opacity: 0.5">No se encuentraron resultados</em>
  </template>
  </Vue-select>
</template>

<script>
  import { ref, watchEffect } from 'vue';
  
  export default {
    props: {
      data: Array,
      selectedCountrie: String
    },
    setup(props, { emit }) {
      const selectedInternal = ref(null);

      watchEffect(() => {
        if (props.selectedCountrie) {
          const selectedOption = props.data.find(option => option.id.toString() === props.selectedCountrie);
          selectedInternal.value = selectedOption;
        }
      });

      watchEffect(() => {
        if (selectedInternal.value !== null) {
          if (selectedInternal.value) {
            const selectedId = selectedInternal.value.id;

            const idAsString = selectedId ? selectedId.toString() : null;
            emit('update:selectedCountrie', selectedInternal.value);
            if (idAsString) {
              selectedInternal.value = idAsString;
              emit('update:selectedCountrie', idAsString);
            }
          }
        }
      });

      const clearSelection = () => {
        selectedInternal.value = '';
        emit('update:selectedCountrie', selectedInternal.value );
      };

      const Deselect = null;

    return {
      selectedInternal,
      clearSelection,
      Deselect
    };
  }
};
</script>